import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography, Paper, RadioGroup, Radio as MRadio, FormControlLabel} from 'views/components';
import {Translate, translate} from 'views/module';

const StartDate = (props) => {
  const {setIsStepValid, newJob, updateJobStartDate} = props;

  // Start date options array - get keys from translation object
  const startDateOptionsObject = translate('career.create.StartDate.Options');
  const startDateOptions = Object.keys(startDateOptionsObject);
  const selected = newJob?.startDate?.startTime || '';

  const handleSelect = (key) => {
    // Update the job data using the provided update function
    updateJobStartDate((currentStartDate) => ({
      ...currentStartDate,
      startTime: key,
    }));
  };

  React.useEffect(() => {
    setIsStepValid(selected !== '');
  }, [setIsStepValid, selected]);

  return (
    <Box sx={{maxWidth: 800, margin: 'auto', padding: '0'}}>
      <Box sx={{marginBottom: 4}}>
        <Typography variant="h4" sx={{fontWeight: 700, fontSize: 28, marginBottom: 1}}>
          <Translate expression="career.create.StartDate.Title" />
        </Typography>
        <Typography variant="body1" sx={{color: 'text.secondary', fontSize: 16}}>
          <Translate expression="career.create.StartDate.Subtitle" />
        </Typography>
      </Box>
      <RadioGroup
        label=""
        value={selected}
        onChange={handleSelect}
      >
        {
          startDateOptions.map((optionKey) => (
            <Paper
              key={optionKey}
              sx={{
                'mb': 1,
                'p': 2,
                'minWidth': 800,
                'cursor': 'pointer',
              }}
              onClick={() => handleSelect(optionKey)}
            >
              <FormControlLabel
                value={optionKey}
                control={<MRadio label="" />}
                sx={{ml: 2}}
                label={
                  <Box sx={{ml: 1}}>
                    <Typography variant="h6" sx={{fontWeight: 600, fontSize: 16, mb: 0.5}}>
                      <Translate expression={`career.create.StartDate.Options.${optionKey}.Label`} />
                    </Typography>
                    <Typography variant="body2" sx={{color: 'text.secondary', fontSize: 14}}>
                      <Translate expression={`career.create.StartDate.Options.${optionKey}.Description`} />
                    </Typography>
                  </Box>
                }
              />
            </Paper>
          ))
        }
      </RadioGroup>
    </Box>
  );
};

StartDate.propTypes = {
  setIsStepValid: PropTypes.func.isRequired,
  newJob: PropTypes.object.isRequired,
  updateJobStartDate: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  onContinue: PropTypes.func,
};

export default StartDate;
